import styled from 'styled-components';

const PageContainer = styled.div`
  min-height: 80vh;
  max-width: ${({ plain, maxWidth = '1100px' }) => (plain ? 'none' : maxWidth)};
  margin: ${({ plain }) => (plain ? '0' : '3rem auto')};
  padding: 2rem;
  ${({ plain, theme }) =>
    plain
      ? ''
      : `
  background-color: ${theme.colors.backgroundReverse};
  color: ${theme.colors.textReverse};
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  `}
`;

export default PageContainer;